import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, apiError } from "@/lib/api";
import "./Home.css";
import "./Auth.css";

const A = "/remy";

const MailIcon = (
  <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2" /><path d="m22 7-10 6L2 7" />
  </svg>
);
const LockIcon = (
  <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      const me = await api.get("/auth/me").then((r) => r.data).catch(() => null);
      if (me?.is_platform_admin) {
        navigate("/admin");
        return;
      }
      const phones = await api.get("/phone/list").then((r) => r.data).catch(() => []);
      const hasVerified = phones.some((p: any) => p.verified);
      navigate(hasVerified ? "/simulator" : "/onboarding");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="remy-home remy-auth" data-testid="login-page">
      <header className="remy-auth__nav">
        <Link to="/" className="remy-auth__brand" data-testid="login-brand">
          <img className="ic" src={`${A}/icon.png`} alt="" aria-hidden />
          <img className="wd" src={`${A}/wordmark.png`} alt="Remy" />
        </Link>
      </header>

      <main className="remy-auth__main">
        <div className="remy-auth__card">
          <h1 className="remy-auth__title">Welcome back</h1>
          <p className="remy-auth__sub">Log in to your Remy companion.</p>

          <form onSubmit={submit} data-testid="login-form">
            <label className="rh-input rh-input--mb" htmlFor="email">
              {MailIcon}
              <input id="email" type="email" required value={email} data-testid="login-email"
                autoComplete="email" onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
            </label>
            <label className="rh-input rh-input--mb" htmlFor="password">
              {LockIcon}
              <input id="password" type="password" required value={password} data-testid="login-password"
                autoComplete="current-password" onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
            </label>
            <button type="submit" className="rh-btn rh-btn--block" disabled={loading} data-testid="login-submit">
              {loading ? "Logging in…" : "Log in"}
            </button>
          </form>

          <p className="remy-auth__foot">
            No account?{" "}
            <Link to="/signup" data-testid="go-signup">Create one</Link>
          </p>
        </div>
      </main>
    </div>
  );
}
